// src/modules/app-views/crm/components/CardHeaderColumn2.jsx
// *******************************************************************************
// CRM CARD HEADER - COLUMN 2: Lead contact snapshot (phone, email, uniqueId)
// *******************************************************************************
// Displays the contact info frozen at lead distribution time.
// Uses the same pattern as CardHeaderLeadsCol2.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { FileProtectOutlined } from '@ant-design/icons';
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { phoneItem } from 'layouts/Pages/PageHeader/CardHeaderColumn/items/phone';
import { emailItem } from 'layouts/Pages/PageHeader/CardHeaderColumn/items/email';
import translateX from 'utils/translateX';
import appService from 'services/appService';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CrmCardHeaderColumn2 = props => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  // contactPhone / contactEmail / contactUniqueId are stored on the CRM opportunity
  // as a snapshot of the originating lead's contact info at distribution time.
  // Fall back to __lead fields for opportunities created before the snapshot was introduced.
  const lead = props?.__lead || {};
  const uniqueId = props?.contactUniqueId || lead?.uniqueId || null;

  // phoneItem and emailItem expect record.phone and record.email respectively
  const record = {
    ...props,
    phone: props?.contactPhone || lead?.phone || null,
    email: props?.contactEmail || lead?.email || null,
  };

  const items = [
    {
      key: 'uniqueId',
      icon: <FileProtectOutlined />,
      label: uniqueId,
      tooltipText: translateX('unique_id'),
      tooltipPlacement: 'right',
      onClick: uniqueId ? () => appService.handleCopyToClipboard(uniqueId, 'copied') : null,
    },
    phoneItem(record),
    emailItem(record),
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items.filter(i => i?.label)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CrmCardHeaderColumn2;
